// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"618":"852bbd26489c0326","2888":"eab0a5fddce7be4c","7168":"b5429893e4eb7820","8960":"ca766e9d030f506b"}[chunkId] + ".css";
};